import { Factory } from 'miragejs';

export default Factory.extend({
  secretKey: i => `secret${i * 42 + 123}`,
});
